import { l } from '@manychat/manyui'

import {
  IMenuPartialRootState,
  DEFAULT_MENU_VALUE,
  getDefaultMenuLabel,
} from 'apps/menu/constants/constants'
import { IMenu, IMenuListState, FetchStatus } from 'apps/menu/menuInterfaces'

const getMenusListState = (state: IMenuPartialRootState): IMenuListState => state.menu.list

export const getMenus = (state: IMenuPartialRootState): IMenu[] => getMenusListState(state).items

export const getById = (state: IMenuPartialRootState, id: string): IMenu | undefined => {
  return getMenus(state).find((menu) => menu.id === id)
}

export const getFetchStatus = (state: IMenuPartialRootState): FetchStatus =>
  getMenusListState(state).fetchStatus

export const getCreateStatus = (state: IMenuPartialRootState): FetchStatus =>
  getMenusListState(state).createStatus

export const getIsFetching = (state: IMenuPartialRootState): boolean =>
  getFetchStatus(state) === FetchStatus.FETCHING

export const getSetMainMenuActionOptions = (state: IMenuPartialRootState) => {
  const menus = getMenus(state)
  return [{ name: l.getString(getDefaultMenuLabel), id: DEFAULT_MENU_VALUE }, ...menus]
}
